// @flow

import * as React from 'react';

import { useSelector } from 'react-redux';

import {
  useTranslator,
  localeSelector as selectLocale,
} from '@gandi/translate';

import { selectLoginEndpoint, selectShopURL } from 'src/modules/config';
import { pathjoin } from 'src/modules/pathjoin';

import { UserActionRow } from './UserActionRow';

function LoginRow(): React.MixedElement {
  const { __ } = useTranslator();
  const locale = useSelector(selectLocale);
  const loginEndpoint = useSelector(selectLoginEndpoint);

  const shopURL = useSelector(selectShopURL);

  const renewHref = pathjoin(shopURL, locale, 'domain', 'renew');

  const encodedRenewHref = encodeURIComponent(renewHref);

  const href = `${loginEndpoint}/${locale}/login?redirect=${encodedRenewHref}`;

  return (
    <UserActionRow
      href={href}
      message={__(
        'You can log in to see which products need renewal at this time.',
      )}
      buttonLabel={__('Log in')}
    />
  );
}

export default LoginRow;
